import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d8eeebd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-global hr-settings" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "hr-heading" }
const _hoisted_4 = { class: "page-title" }
const _hoisted_5 = { class: "hr-toggle" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "hr-error"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = { class: "hr-table" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col"),
  /*#__PURE__*/_createElementVNode("col", { class: "hr-required-column" }),
  /*#__PURE__*/_createElementVNode("col", { class: "hr-expiry-column" }),
  /*#__PURE__*/_createElementVNode("col", { class: "hr-esign-column" }),
  /*#__PURE__*/_createElementVNode("col", { class: "hr-order-column" }),
  /*#__PURE__*/_createElementVNode("col", { class: "hr-status-column" }),
  /*#__PURE__*/_createElementVNode("col", { class: "hr-actions-column" })
], -1))
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "hr-actions-heading" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { colspan: "7" }
const _hoisted_16 = { class: "hr-type-name" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "hr-actions" }
const _hoisted_19 = ["disabled", "onClick"]
const _hoisted_20 = ["disabled", "onClick"]
const _hoisted_21 = ["onSubmit"]
const _hoisted_22 = {
  key: 0,
  class: "hr-error"
}

import BackButton from "@/components/common/BackButton.vue";
import { onMounted, reactive, ref } from "vue";
import { Button } from "@/components/common";
import Modal from "@/components/common/Modal.vue";
import HrDataService from "@/services/hr/HrDataService";
import HrNotificationSettings from "@/components/hr/HrNotificationSettings.vue";
import HrAssistantAccessSettings from "@/components/hr/HrAssistantAccessSettings.vue";
import { HrDocumentType } from "@/types/hr/Hr";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

/* Legacy ESLint does not detect template usage from script setup. */
/* eslint-disable @typescript-eslint/no-unused-vars */
const types = ref<HrDocumentType[]>([]);
const includeArchived = ref(false);
const modalOpen = ref(false);
const editing = ref<HrDocumentType | null>(null);
const error = ref("");
const modalError = ref("");
const loading = ref(false);
const saving = ref(false);
const archivingTypeId = ref("");
const form = reactive({
  name: "",
  description: "",
  required: false,
  requiresExpiryDate: false,
  allowsEsignLink: false,
  sortOrder: 0,
  status: "ACTIVE",
});
async function load() {
  if (loading.value) return;
  loading.value = true;
  error.value = "";
  try {
    const response = await HrDataService.getDocumentTypes(
      includeArchived.value
    );
    types.value = response.data.data;
  } catch (exception: unknown) {
    error.value = apiErrorMessage(exception, t("hr.loadError"));
  } finally {
    loading.value = false;
  }
}
function openCreate() {
  editing.value = null;
  modalError.value = "";
  Object.assign(form, {
    name: "",
    description: "",
    required: false,
    requiresExpiryDate: false,
    allowsEsignLink: false,
    sortOrder: types.value.length,
    status: "ACTIVE",
  });
  modalOpen.value = true;
}
function openEdit(item: HrDocumentType) {
  editing.value = item;
  modalError.value = "";
  Object.assign(form, item);
  modalOpen.value = true;
}
function closeModal() {
  if (!saving.value) modalOpen.value = false;
}
async function save() {
  if (saving.value) return;
  modalError.value = "";
  saving.value = true;
  try {
    editing.value
      ? await HrDataService.updateDocumentType(editing.value.id, form)
      : await HrDataService.createDocumentType(form);
    modalOpen.value = false;
    await load();
  } catch (exception: unknown) {
    modalError.value = apiErrorMessage(exception, t("hr.saveError"));
  } finally {
    saving.value = false;
  }
}
async function archiveType(item: HrDocumentType) {
  if (archivingTypeId.value || !window.confirm(t("hr.archiveTypeConfirm")))
    return;
  error.value = "";
  archivingTypeId.value = item.id;
  try {
    await HrDataService.archiveDocumentType(item.id);
    await load();
  } catch (exception: unknown) {
    error.value = apiErrorMessage(exception, t("hr.saveError"));
  } finally {
    archivingTypeId.value = "";
  }
}
function apiErrorMessage(exception: unknown, fallback: string) {
  const response = exception as { response?: { data?: { message?: string } } };
  return response.response?.data?.message || fallback;
}
onMounted(load);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackButton, {
      to: { name: 'HrEmployeeList' },
      class: "mb-4"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)("hr.settings")), 1),
      _createVNode(HrNotificationSettings),
      _createVNode(HrAssistantAccessSettings),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(t)("hr.documentTypes")), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(t)("hr.documentTypesHint")), 1)
        ]),
        _createVNode(_unref(Button), {
          disabled: loading.value || saving.value || Boolean(archivingTypeId.value),
          onClick: openCreate
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("hr.addDocumentType")), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createElementVNode("label", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((includeArchived).value = $event)),
          type: "checkbox",
          disabled: loading.value,
          onChange: load
        }, null, 40, _hoisted_6), [
          [_vModelCheckbox, includeArchived.value]
        ]),
        _createTextVNode(" " + _toDisplayString(_unref(t)("hr.showArchived")), 1)
      ]),
      (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(error.value), 1))
        : _createCommentVNode("", true),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(t)("hr.loading")), 1))
        : (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "hr-table-scroll",
            tabindex: "0",
            "aria-label": _unref(t)('hr.documentTypes')
          }, [
            _createElementVNode("table", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, _toDisplayString(_unref(t)("hr.documentTypeName")), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(t)("hr.required")), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(t)("hr.expiryRequired")), 1),
                  _createElementVNode("th", {
                    title: _unref(t)('hr.esignLinkHint')
                  }, _toDisplayString(_unref(t)("hr.esignLink")), 9, _hoisted_12),
                  _createElementVNode("th", null, _toDisplayString(_unref(t)("hr.order")), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(t)("common.status")), 1),
                  _createElementVNode("th", _hoisted_13, _toDisplayString(_unref(t)("common.actions")), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (!types.value.length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                      _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(t)("common.noData")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(types.value, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("strong", null, _toDisplayString(item.name), 1),
                        (item.description)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_17, _toDisplayString(item.description), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.required ? _unref(t)("common.yes") : _unref(t)("common.no")), 1),
                    _createElementVNode("td", null, _toDisplayString(item.requiresExpiryDate ? _unref(t)("common.yes") : _unref(t)("common.no")), 1),
                    _createElementVNode("td", null, _toDisplayString(item.allowsEsignLink ? _unref(t)("common.yes") : _unref(t)("common.no")), 1),
                    _createElementVNode("td", null, _toDisplayString(item.sortOrder), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass({ 'tag tag--success': item.status === 'ACTIVE' })
                      }, _toDisplayString(item.status === "ACTIVE"
                    ? _unref(t)("status.active")
                    : _unref(t)("hr.statusArchived")), 3)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("button", {
                          type: "button",
                          disabled: Boolean(archivingTypeId.value) || saving.value,
                          onClick: ($event: any) => (openEdit(item))
                        }, _toDisplayString(_unref(t)("common.edit")), 9, _hoisted_19),
                        (item.status === 'ACTIVE')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "hr-danger",
                              disabled: Boolean(archivingTypeId.value) || saving.value,
                              onClick: ($event: any) => (archiveType(item))
                            }, _toDisplayString(archivingTypeId.value === item.id
                      ? _unref(t)("hr.archiving")
                      : _unref(t)("hr.archive")), 9, _hoisted_20))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ], 8, _hoisted_9)),
      _createVNode(Modal, {
        show: modalOpen.value,
        title: editing.value ? _unref(t)('hr.editDocumentType') : _unref(t)('hr.addDocumentType'),
        onClose: closeModal
      }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            class: "hr-type-form",
            onSubmit: _withModifiers(save, ["prevent"])
          }, [
            (modalError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(modalError.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("label", null, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("hr.documentTypeName")) + " *", 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).name) = $event)),
                class: "input-form",
                required: ""
              }, null, 512), [
                [
                  _vModelText,
                  _unref(form).name,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("label", null, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("hr.description")), 1),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).description) = $event)),
                class: "input-form",
                rows: "3"
              }, null, 512), [
                [
                  _vModelText,
                  _unref(form).description,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("label", null, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("hr.order")), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).sortOrder) = $event)),
                class: "input-form",
                type: "number",
                min: "0"
              }, null, 512), [
                [
                  _vModelText,
                  _unref(form).sortOrder,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).required) = $event)),
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, _unref(form).required]
              ]),
              _createTextVNode(" " + _toDisplayString(_unref(t)("hr.required")), 1)
            ]),
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).requiresExpiryDate) = $event)),
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, _unref(form).requiresExpiryDate]
              ]),
              _createTextVNode(" " + _toDisplayString(_unref(t)("hr.expiryRequired")), 1)
            ]),
            _createElementVNode("label", null, [
              _createElementVNode("span", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).allowsEsignLink) = $event)),
                  type: "checkbox"
                }, null, 512), [
                  [_vModelCheckbox, _unref(form).allowsEsignLink]
                ]),
                _createTextVNode(" " + _toDisplayString(_unref(t)("hr.allowEsignLink")), 1)
              ]),
              _createElementVNode("small", null, _toDisplayString(_unref(t)("hr.esignLinkHint")), 1)
            ]),
            _createVNode(_unref(Button), {
              type: "submit",
              disabled: saving.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(saving.value ? _unref(t)("hr.saving") : _unref(t)("common.save")), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ], 40, _hoisted_21)
        ]),
        _: 1
      }, 8, ["show", "title"])
    ])
  ], 64))
}
}

})